import React from 'react';

import robustAirframeDrone from '../../../main/assets/images/mrm2-10/robust-airframe-drone.webp';

export const RobustAirframe = () => {
  return (
    <section className="mrm2-robust-container">
      <div className="mrm2-robust-section">
        <div className="mrm2-robust-text">
          <div className="mrm2-robust-text-content">
            <h2 className="mrm2-robust-title">
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                HIGH POWER
              </span>{' '}
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                PLATFORM
              </span>
            </h2>
            <p className="mrm2-robust-description">
              Built from featherweight carbon fibre, the{' '}
              <span style={{ whiteSpace: 'nowrap' }}>MRM2-10’s</span> 10” prop
              configuration delivers an impressive balance of stability and
              power, making it the perfect platform for diverse payloads up to{' '}
              <span style={{ whiteSpace: 'nowrap' }}>3.5 kg.</span>
            </p>
          </div>
          <div className="mrm2-robust-text-content">
            <div>
              <h2 className="mrm2-robust-title">
                <span style={{ whiteSpace: 'nowrap' }}>INTELLIGENT</span>{' '}
              </h2>
              <h2 className="mrm2-robust-title">INTEGRATION</h2>
            </div>
            <p className="mrm2-robust-description">
              The <span style={{ whiteSpace: 'nowrap' }}>MRM2-10’s</span>{' '}
              state-of-the-art H743 core supports both professional firmwares
              like Ardupilot and iNav, and native integration with the Orqa{' '}
              <span style={{ whiteSpace: 'nowrap' }}>Tac.Ctrl</span> and Ground
              Station. Full MAVLINK support ensures flawless connectivity to
              existing C2 ecosystems, including ATAK.
            </p>
          </div>
        </div>
        <img
          src={robustAirframeDrone}
          alt="Airframe Product with reflection"
          className="mrm2-robust-product"
        />
      </div>
    </section>
  );
};
